import { render } from "./AudioInfo.vue?vue&type=template&id=04e8520c&bindings={\"stream\":\"props\"}"
import script from "./AudioInfo.vue?vue&type=script&lang=js"
export * from "./AudioInfo.vue?vue&type=script&lang=js"
script.render = render

export default script